import { GrCircleInformation } from "react-icons/gr";

const ReportForm = () => {
  const options = [
    "Inappropriate Language",
    "False information",
    "Spam Review",
    "Harrasement/Personal Attack",
    "Other (Specify)",
  ];
  return (
    <div className="flex flex-col gap-4 w-96">
      <h2 className="font-bold text-lg">Reason for Reporting</h2>
      <div className="flex flex-col ml-5">
        {options.map((option, index) => (
          <div key={index} className="flex items-center mb-2">
            <input
              type="radio"
              name="reportReason"
              id={`option-${index}`}
              className="accent-[#F16631] mr-2 cursor-pointer w-4 h-4 "
            />
            <label htmlFor={`option-${index}`} className="text-sm">
              {option}
            </label>
          </div>
        ))}
      </div>
      <div>
        <h2 className="text-gray-500 text-sm mb-1">Comment Box</h2>
        <textarea
          className="w-full p-2 border border-gray-300 rounded-md resize-none overflow-y-auto outline-none"
          rows="2"
          placeholder="Please provide additional details..."
        ></textarea>
      </div>
      <div className="flex justify-end gap-3">
        <button className="bg-gray-200 text-gray-700 font-semibold py-2 px-4 rounded-md">
          Cancel
        </button>
        <button className="bg-[#F16631] text-white font-semibold py-2 px-4 rounded-md cursor-pointer transition duration-200">
          Submit Report
        </button>
      </div>
      <hr className="w-full border-[#F16631] border-opacity-30" />
      <div className="flex items-center justify-center gap-2 text-[#F16631] text-sm">
        <GrCircleInformation />
        <p>False report may result in consequences.</p>
      </div>
    </div>
  );
};
export default ReportForm;
